import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from '../../utils/useRouter';
import MasterLayout from '../../components/AppLayout/MasterLayout';
import { routes } from '../../constants';
import './KeycloakSSORedirect.scss';
import useAction from '../../utils/useAction';
import { loginKeycloakUser } from '../../actions/auth.actions';
import { selectIsAuthenticated } from '../../reducers/user.selectors';
import { useSelector } from 'react-redux';

const KeycloakSSORedirect: React.FC = () => {
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [isFetchingAuth, setIsFetchingAuth] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const loginKeycloakUserAction = useAction(loginKeycloakUser);
  const { router, match: { location: { query: { code } } } } = useRouter();

  if (!code) {
    router.push(`/${routes.notFound.root}`);
  }

  useEffect(() => {
    loginKeycloakUserAction(code)
      .then(() => setIsFetchingAuth(false))
      .catch(error => {
        if (error.message.match(/Email address already exists/)) {
          setError(t('This Email address already exists'));
        } else {
          router.push(`/${routes.notFound.root}`);
        }
      });
    setTimeout(() => setIsFetchingAuth(false), 3300);
  }, [code]);

  useEffect(() => {
    if (!isFetchingAuth && isAuthenticated) {
      router.push(`/${routes.dashboard.root}`);
    }
  }, [isFetchingAuth, isAuthenticated]);

  return (
    <MasterLayout>
      <div className='sso'>
        <div className='sso-header'>{t('Please wait a moment')}</div>
        {
          error
            ? <div className='sso-description sso-error'>{error}. {t('Please contact our support-team.')}</div>
            : <div className='sso-description'>{t('We are connecting meinUnterricht with the login provider.')}</div>
        }
      </div>
    </MasterLayout>
  );
};

export default KeycloakSSORedirect;
